module.exports = __webpack_public_path__ + "static/haidilao-fb0993255e86becc727e53c2b5de475a.png";